(function () {
    function el(tag, cls) { var e = document.createElement(tag); if (cls) e.className = cls; return e; }
    function focusHeading(node) {
      if (!node) return;
      node.setAttribute('tabindex', '-1');
      try { node.focus({ preventScroll: true }); } catch (e) { node.focus(); }
    }

    function initRoot(root) {
      if (root.dataset.nclInit) return;
      root.dataset.nclInit = '1';
      var cfg, products;
      try {
        cfg = JSON.parse(root.querySelector('[data-ncl-quiz-config]').textContent);
        products = JSON.parse(root.querySelector('[data-ncl-quiz-products]').textContent);
      } catch (e) { return; }

      var dialog = root.querySelector('[data-ncl-quiz-dialog]');
      var stage = root.querySelector('[data-ncl-quiz-stage]');
      var bar = root.querySelector('[data-ncl-quiz-bar]');
      var questions = (cfg.questions || []).slice().sort(function (a, b) { return a.ordering - b.ordering; });
      var byId = {};
      questions.forEach(function (q) { byId[String(q.id)] = q; });
      var welcomeHeading = root.dataset.welcomeHeading || (cfg.welcome && cfg.welcome.heading) || 'Find your match';
      var welcomeText = (cfg.welcome && cfg.welcome.text) || '';
      var resultHeading = root.dataset.resultHeading || (cfg.result && cfg.result.heading) || '';
      var disclaimer = (cfg.result && cfg.result.disclaimer) || '';
      var alsoOn = !(cfg.result && cfg.result.youMayAlsoLike === false);
      var subheadingEmail = (cfg.result && cfg.result.subheadingEmail) || '';
      var klaviyo = cfg.klaviyo || null;

      var state = { answers: {}, history: [] };
      var emailEntered = false;

      function open() {
        state = { answers: {}, history: [] };
        emailEntered = false;
        setProgress(0);
        renderWelcome();
        if (typeof dialog.showModal === 'function') { dialog.showModal(); } else { dialog.setAttribute('open', ''); }
      }
      function close() { if (dialog.open) dialog.close(); }
      root.querySelectorAll('[data-ncl-quiz-open]').forEach(function (b) { b.addEventListener('click', open); });
      root.querySelectorAll('[data-ncl-quiz-close]').forEach(function (b) { b.addEventListener('click', close); });
      dialog.addEventListener('click', function (e) { if (e.target === dialog) close(); });

      function setProgress(p) { if (bar) bar.style.width = Math.max(0, Math.min(100, p)) + '%'; }
      function selectedFor(q) {
        var aid = state.answers[String(q.id)];
        if (aid == null) return null;
        return q.answers.find(function (a) { return a.id === aid; });
      }
      function nextId(q, ans) {
        var j = ans ? String(ans.jumpTo || '') : '';
        if (j === '-3') return '__result__';
        if (j && j !== '-2' && byId[j]) return j;
        var idx = questions.findIndex(function (x) { return String(x.id) === String(q.id); });
        if (idx >= 0 && idx < questions.length - 1) return String(questions[idx + 1].id);
        return '__result__';
      }

      function renderWelcome() {
        setProgress(0);
        stage.innerHTML = '';
        var w = el('div', 'ncl-quiz__welcome');
        var h = el('h2'); h.textContent = welcomeHeading; w.appendChild(h);
        if (welcomeText) { var t = el('div', 'ncl-quiz__welcome-text'); t.innerHTML = welcomeText; w.appendChild(t); }
        var start = el('button', 'ncl-quiz__btn ncl-quiz__btn--primary'); start.type = 'button'; start.textContent = 'Start';
        start.addEventListener('click', function () { if (questions.length) go(String(questions[0].id)); });
        w.appendChild(start);
        stage.appendChild(w);
        focusHeading(h);
      }

      function go(qid) {
        if (qid === '__result__') { renderResult(); return; }
        var q = byId[qid];
        if (q.type === 'email') { renderEmail(q); } else { renderQuestion(q); }
        var idx = questions.findIndex(function (x) { return String(x.id) === String(qid); });
        setProgress((idx / questions.length) * 100);
        stage.scrollTop = 0;
      }

      function renderQuestion(q) {
        stage.innerHTML = '';
        var title = el('h2', 'ncl-quiz__q-title'); title.textContent = q.title; stage.appendChild(title);
        if (q.description) { var d = el('p', 'ncl-quiz__q-desc'); d.textContent = q.description; stage.appendChild(d); }

        var nav = el('div', 'ncl-quiz__nav');
        var back = el('button', 'ncl-quiz__btn ncl-quiz__btn--ghost'); back.type = 'button'; back.textContent = 'Back';
        back.addEventListener('click', function () {
          var prev = state.history.pop();
          if (prev == null) renderWelcome(); else go(prev);
        });
        var next = el('button', 'ncl-quiz__btn ncl-quiz__btn--primary'); next.type = 'button'; next.textContent = 'Next';
        next.disabled = state.answers[String(q.id)] == null;
        next.addEventListener('click', function () {
          var ans = selectedFor(q); if (!ans) return;
          state.history.push(String(q.id));
          go(nextId(q, ans));
        });

        var pic = q.type === 'pictureChoice';
        var ul = el('ul', 'ncl-quiz__choices ' + (pic ? 'ncl-quiz__choices--pic' : 'ncl-quiz__choices--radio'));
        if (pic) ul.style.setProperty('--q-cols', q.perRow || 3);
        q.answers.forEach(function (a) {
          var li = el('li');
          var btn = el('button', 'ncl-quiz__choice'); btn.type = 'button';
          btn.setAttribute('aria-pressed', state.answers[String(q.id)] === a.id ? 'true' : 'false');
          if (pic && a.image) { var im = el('img', 'ncl-quiz__choice-img'); im.src = a.image; im.alt = a.title; im.loading = 'lazy'; btn.appendChild(im); }
          var lab = el('span', 'ncl-quiz__choice-label'); lab.textContent = a.title; btn.appendChild(lab);
          btn.addEventListener('click', function () {
            state.answers[String(q.id)] = a.id;
            ul.querySelectorAll('.ncl-quiz__choice').forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
            btn.setAttribute('aria-pressed', 'true');
            next.disabled = false;
          });
          li.appendChild(btn); ul.appendChild(li);
        });

        stage.appendChild(ul);
        nav.appendChild(back); nav.appendChild(next);
        stage.appendChild(nav);
        focusHeading(title);
      }

      function renderEmail(q) {
        stage.innerHTML = '';
        var title = el('h2', 'ncl-quiz__q-title'); title.textContent = q.title; stage.appendChild(title);
        if (q.description) { var d = el('p', 'ncl-quiz__q-desc'); d.textContent = q.description; stage.appendChild(d); }

        var form = el('div', 'ncl-quiz__email');
        var input = document.createElement('input');
        input.type = 'email'; input.className = 'ncl-quiz__email-input';
        input.placeholder = 'you@email.com'; input.autocomplete = 'email';
        input.setAttribute('aria-label', q.title || 'Email address');
        form.appendChild(input);

        var gdpr = null;
        if (q.gdprText) {
          var lbl = el('label', 'ncl-quiz__gdpr');
          gdpr = document.createElement('input'); gdpr.type = 'checkbox'; gdpr.className = 'ncl-quiz__gdpr-box';
          var span = el('span'); span.textContent = q.gdprText;
          lbl.appendChild(gdpr); lbl.appendChild(span); form.appendChild(lbl);
        }
        var err = el('p', 'ncl-quiz__email-err'); err.style.display = 'none';
        err.setAttribute('role', 'alert');
        form.appendChild(err);
        stage.appendChild(form);

        var nav = el('div', 'ncl-quiz__nav');
        var back = el('button', 'ncl-quiz__btn ncl-quiz__btn--ghost'); back.type = 'button'; back.textContent = 'Back';
        back.addEventListener('click', function () { var prev = state.history.pop(); if (prev == null) renderWelcome(); else go(prev); });
        var submit = el('button', 'ncl-quiz__btn ncl-quiz__btn--primary'); submit.type = 'button'; submit.textContent = q.submitText || 'Submit';
        submit.addEventListener('click', function () {
          var email = (input.value || '').trim();
          if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) { err.textContent = 'Please enter a valid email.'; err.style.display = 'block'; return; }
          if (gdpr && q.gdprRequired && !gdpr.checked) { err.textContent = 'Please agree to continue.'; err.style.display = 'block'; return; }
          err.style.display = 'none';
          submit.disabled = true; submit.textContent = 'Submitting...';
          subscribe(email, function () { emailEntered = true; go('__result__'); });
        });
        nav.appendChild(back); nav.appendChild(submit);
        stage.appendChild(nav);

        if (!q.required) {
          var skip = el('button', 'ncl-quiz__skip'); skip.type = 'button'; skip.textContent = q.skipButtonText || 'No thanks';
          skip.addEventListener('click', function () { go('__result__'); });
          stage.appendChild(skip);
        }
        focusHeading(title);
      }

      function subscribe(email, done) {
        if (!klaviyo || !klaviyo.companyId || !klaviyo.listId) { done(); return; }
        var body = {
          data: {
            type: 'subscription',
            attributes: { profile: { data: { type: 'profile', attributes: { email: email } } } },
            relationships: { list: { data: { type: 'list', id: klaviyo.listId } } }
          }
        };
        fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(klaviyo.companyId), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
          body: JSON.stringify(body)
        }).then(function () { done(); }).catch(function () { done(); });
      }

      function compute() {
        var score = {}, count = {}, excluded = {};
        Object.keys(state.answers).forEach(function (qid) {
          var q = byId[qid]; if (!q) return;
          var aid = state.answers[qid];
          var a = q.answers.find(function (x) { return x.id === aid; });
          if (!a) return;
          (a.exclude || []).forEach(function (h) { excluded[h] = true; });
          (a.include || []).forEach(function (h) { score[h] = (score[h] || 0) + (a.weight || 0); count[h] = (count[h] || 0) + 1; });
        });
        var list = Object.keys(score).filter(function (h) { return !excluded[h] && products[h]; });
        list.sort(function (a, b) { return (score[b] - score[a]) || (count[b] - count[a]); });
        if (!list.length) {
          ['l-lysine-monolaurin', 'monolaurin', 'immunesupport'].forEach(function (h) {
            if (products[h] && list.indexOf(h) < 0) list.push(h);
          });
        }
        return list;
      }

      function productCard(h, primary) {
        var p = products[h];
        var card = el(primary ? 'div' : 'a', primary ? 'ncl-quiz__product' : 'ncl-quiz__also-item');
        if (!primary) { card.href = p.url; }
        var img = el('img', primary ? 'ncl-quiz__product-img' : 'ncl-quiz__also-img');
        img.src = p.image; img.alt = p.title; img.loading = 'lazy';
        var info = el('div', primary ? 'ncl-quiz__product-info' : 'ncl-quiz__also-info');
        var t = el(primary ? 'h3' : 'span', primary ? 'ncl-quiz__product-title' : 'ncl-quiz__also-title'); t.textContent = p.title;
        var pr = el('span', primary ? 'ncl-quiz__product-price' : 'ncl-quiz__also-price'); pr.textContent = p.price;
        info.appendChild(t); info.appendChild(pr);
        if (primary) {
          var actions = el('div', 'ncl-quiz__product-actions');
          var atc = el('button', 'ncl-quiz__btn ncl-quiz__btn--primary'); atc.type = 'button';
          atc.textContent = p.available ? 'Add to cart' : 'Sold out';
          atc.disabled = !p.available || !p.variantId;
          atc.addEventListener('click', function () { addToCart(p.variantId, atc); });
          var view = el('a', 'ncl-quiz__btn ncl-quiz__btn--ghost'); view.href = p.url; view.textContent = 'View product';
          actions.appendChild(atc); actions.appendChild(view); info.appendChild(actions);
          card.appendChild(img); card.appendChild(info);
        } else {
          card.appendChild(img); card.appendChild(info);
        }
        return card;
      }

      function renderResult() {
        setProgress(100);
        stage.innerHTML = '';
        var list = compute();
        var wrap = el('div', 'ncl-quiz__result');
        var firstHeading = null;
        if (resultHeading) { var h = el('h2', 'ncl-quiz__result-heading'); h.textContent = resultHeading; wrap.appendChild(h); firstHeading = h; }
        if (emailEntered && subheadingEmail) { var sub = el('div', 'ncl-quiz__result-sub'); sub.innerHTML = subheadingEmail; wrap.appendChild(sub); }
        if (list[0] && products[list[0]]) wrap.appendChild(productCard(list[0], true));
        var also = list.slice(1, 4).filter(function (h) { return products[h]; });
        if (alsoOn && also.length) {
          var alsoWrap = el('div', 'ncl-quiz__also');
          var at = el('h4', 'ncl-quiz__also-heading'); at.textContent = 'You may also like'; alsoWrap.appendChild(at);
          var grid = el('div', 'ncl-quiz__also-grid');
          also.forEach(function (h) { grid.appendChild(productCard(h, false)); });
          alsoWrap.appendChild(grid); wrap.appendChild(alsoWrap);
        }
        if (disclaimer) { var dc = el('div', 'ncl-quiz__disclaimer'); dc.innerHTML = disclaimer; wrap.appendChild(dc); }
        var retake = el('button', 'ncl-quiz__btn ncl-quiz__btn--ghost'); retake.type = 'button'; retake.textContent = 'Retake quiz';
        retake.addEventListener('click', function () { state = { answers: {}, history: [] }; emailEntered = false; renderWelcome(); });
        wrap.appendChild(retake);
        stage.appendChild(wrap);
        focusHeading(firstHeading || wrap);
      }

      function addToCart(variantId, btn) {
        if (!variantId) return;
        var orig = btn.textContent; btn.disabled = true; btn.textContent = 'Adding...';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
        }).then(function (r) { if (!r.ok) throw r; return r.json(); })
          .then(function () { window.location.href = '/cart'; })
          .catch(function () { btn.disabled = false; btn.textContent = orig; });
      }
    }

    function initAll() { document.querySelectorAll('[data-ncl-quiz]').forEach(initRoot); }
    if (document.readyState !== 'loading') { initAll(); } else { document.addEventListener('DOMContentLoaded', initAll); }
  })();
